import {motion} from 'framer-motion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faArrowUp} from '@fortawesome/free-solid-svg-icons';
import '../CSS/ContactLetterClosed.scss'

const ContactClosed = ({setIsOpen, isFront, setIsFront}) =>{
    const clicked = () =>{
        setIsFront(!isFront)
    }

    return(
        <motion.div 
        exit={{opacity: 0}}
        transition={{duration: .5}}
        >
            <motion.h2 onClick={() => clicked()}>Flip Over</motion.h2>
            <motion.div className="letter-opening"
            exit={{opacity: 0}}
            transition={{duration: .75}}
            ></motion.div>
            <div className="letter-seal"
            onClick={() => setIsOpen(true)}>
                <motion.div
                animate={{
                    y: [0, -5, 0, 5, 0] 
                }}
                transition={{
                    duration: 1,
                    repeat: Infinity,
                    ease: 'linear'
                }}>
                    <FontAwesomeIcon icon={faArrowUp}/>
                </motion.div>
                Open
            </div>
        </motion.div>
    )
}

export default ContactClosed;